<!--
 * @Author: Src
 * @Date: 2025-11-18 17:42:22
 * @LastEditTime: 2025-11-20 09:39:05
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/car/components/buttonPopup.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div class="c_popup">
        <div class="van-overlay" style="z-index: 9;"></div>
        <div class="van-popup van-popup--bottom" style="z-index: 10;">
            <slot></slot>
        </div>
    </div>
</template>
<script lang="ts">
import { Vue, Component } from "vue-property-decorator";

@Component
export default class ButtonPopup extends Vue {}
</script>
<style scoped lang="scss">
.c_popup{
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
}
</style>
